import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
//import {IDropdownSettings} from 'ng-multiselect-dropdown';

/*
 * Use this component to create a dropdown with single/multiple selection options, bind to any custom data source,
 * search item with custom placeholder text, limit selection, select/de-select all items
 */
@Component({
  selector: 'clo-input-select-multiple',
  templateUrl: './select-multiple-input.html',
  styleUrls: ['./input.scss'],
  encapsulation: ViewEncapsulation.None // Add this line
})
export class CloInputSelectMultiple implements OnInit {
  /**
   * Objects for the drop down
   */
  @Input() data: Object[];

  /**
   * Objects for the drop down
   */
  @Input() selectedItems: any;

  /**
   * Objects for the drop down
   */
  @Input() dropdownSettings: IDropdownSettings;
// @Input() settings: IDropdownSettings;

  /**
   * String value for the placeholder text of the dropdown
   */
  @Input() placeholder: any;

  /**
   * String value for the error message
   */
  @Input() errorMessage = '';

  /**
   * Form Label for input
   */
  @Input() label: string;

  @Output() valueChange = new EventEmitter();

  defaultSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };


  /*
   * Method called when an option has been selected in the dropdown
   */
  ngOnInit(): void {

    this.dropdownSettings = Object.assign(this.defaultSettings, this.dropdownSettings);
  }

  onSelect(item: any) {
    this.selectedItems.push(item);
    this.valueChange.emit(this.selectedItems);
  }

  onSelectAll(items: any) {
    this.selectedItems = items;
    this.valueChange.emit(this.selectedItems);
  }

  onDeselect(item: any) {
    const index = this.selectedItems.indexOf(item);
    if (index >= 0) {
      this.selectedItems.splice(index, 1);
    }
    this.valueChange.emit(this.selectedItems);
  }

  onDeselectAll(item: any) {
    this.selectedItems = [];
    this.valueChange.emit(this.selectedItems);
  }
}
